import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    flexDirection: "column",
    gap: "calc(2 * var(--rhythm))",
    padding: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      gap: "calc(1 * var(--rhythm))",
      padding: "calc(1 * var(--rhythm))",
    },
  },
});
